import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IMessage, IMessageState } from 'src/types/Message';

const initialState: IMessageState = {
  msgDetails: '',
  open: false,
  severity: 'info'
};

export const message = createSlice({
  name: 'message',
  initialState,
  reducers: {
    clearMessage: state => {
      state.msgDetails = '';
      state.open = false;
      state.severity = 'info';
    },
    setMessage: (state, action: PayloadAction<IMessage>) => {
      state.open = true;
      state.msgDetails = action.payload.msgDetails;
      state.severity = action.payload.severity;
    }
  }
});

export const { clearMessage, setMessage } = message.actions;
